import {DTO} from '@/shared/base/dto';
import {ENDPOINT, METHOD} from '@/constants';
import {
  IBodyAssignTemplateForDepartment,
  IBodyShareTemplateForUser,
  IQueryGetTemplate,
  IQueryGetTemplatePartner,
  IBodyAssignTemplate,
  IQueryGetTemplateAssignList,
  ITemplateSyncFromBO,
  ITemplateImportDecision,
} from '@/types';

export class GetListTemplateDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_LIST;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTemplate;
  constructor(query: IQueryGetTemplate) {
    super();
    this.query = query;
  }
}

export class GetListTemplatePartnerDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_PARTNER;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTemplatePartner;
  constructor(query: IQueryGetTemplatePartner) {
    super();
    this.query = query;
  }
}

export class GetListTemplateAssignDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_ASSIGN_LIST;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetTemplateAssignList;
  constructor(query: IQueryGetTemplateAssignList) {
    super();
    this.query = query;
  }
}

export class CreateTemplateDTO extends DTO {
  public static url = ENDPOINT.TEMPLATE_LIST;
  public url = CreateTemplateDTO.url;
  public method = METHOD.POST;
  public query: undefined;
  public param: undefined;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(public body: any) {
    super();
  }
}
export class DetailTemplateDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DETAIL_TEMPLATE;
  public method = METHOD.GET;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}
export class UpdateTemplateDTO extends DTO {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public body: any;
  public url: string = ENDPOINT.DETAIL_TEMPLATE;
  public method = METHOD.PUT;
  public param: {id: number | undefined};
  public query: undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(param: {id: number | undefined}, body: any) {
    super();
    this.param = param;
    this.body = body;
  }
}
export class DeleteTemplateDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.DETAIL_TEMPLATE;
  public method = METHOD.DELETE;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(param: {id: number}) {
    super();
    this.param = param;
  }
}

export class DeleteMultipleTemplateDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.DELETE_MULTL_TEMPLATE;
  public method = METHOD.DELETE;
  public body: {templateIds: number[]};
  public readonly responseClass: unknown;
  public query: undefined;
  constructor(body: {templateIds: number[]}) {
    super();
    this.body = body;
  }
}

export class GetTemplateCompactDTO extends DTO {
  public url = ENDPOINT.GET_TEMPLATE_COMPACT;
  public method = METHOD.GET;
  public body: undefined;
  public query: undefined;
  public param: undefined;
}
export class AssignTemplateForDepartmentDTO extends DTO {
  public static url = ENDPOINT.TEMPLATE_ASSIGN_DEPARTMENT;
  public url = ENDPOINT.TEMPLATE_ASSIGN_DEPARTMENT;
  public method = METHOD.POST;
  public query: undefined;
  public body: IBodyAssignTemplateForDepartment;
  public param: undefined;

  constructor(body: IBodyAssignTemplateForDepartment) {
    super();
    this.body = body;
  }
}
export class AssignTemplateDTO extends DTO {
  public static url = ENDPOINT.TEMPLATE_ASSIGN;
  public url = ENDPOINT.TEMPLATE_ASSIGN;
  public method = METHOD.POST;
  public query: undefined;
  public body: IBodyAssignTemplate;
  public param: undefined;

  constructor(body: IBodyAssignTemplate) {
    super();
    this.body = body;
  }
}

export class ShareTemplateForUserDTO extends DTO {
  public static url = ENDPOINT.TEMPLATE_SHARE_MANY_USER;
  public url = ENDPOINT.TEMPLATE_SHARE_MANY_USER;
  public method = METHOD.POST;
  public query: undefined;
  public body: IBodyShareTemplateForUser;
  public param: undefined;

  constructor(body: IBodyShareTemplateForUser) {
    super();
    this.body = body;
  }
}

export class DuplicateTemplateDTO extends DTO {
  public static url = ENDPOINT.TEMPLATE_DUPLICATE;
  public url = ENDPOINT.TEMPLATE_DUPLICATE;
  public method = METHOD.POST;
  public query: undefined;
  public body: {templateId: number};
  public param: undefined;

  constructor(body: {templateId: number}) {
    super();
    this.body = body;
  }
}

export class GetCreatedByTemplateDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_COMPACT_CREATED_BY;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: undefined;

  constructor() {
    super();
  }
}

export class GetSyncTemplateBODTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATES_SYNC_FROM_BO;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: undefined;

  constructor() {
    super();
  }
}

export class SyncTemplateBODTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.SYNC_TEMPLATE;
  public method = METHOD.POST;
  public body: {templates: ITemplateSyncFromBO[]};
  public readonly responseClass: unknown;
  public query: undefined;

  constructor(body: {templates: ITemplateSyncFromBO[]}) {
    super();
    this.body = body;
  }
}

export class ExportTemplatesDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_EXPORT;
  public method = METHOD.POST;
  public body: {templateIds: number[]};
  public readonly responseClass: unknown;
  public query: undefined;
  public responseType = 'blob' as const;

  constructor(body: {templateIds: number[]}) {
    super();
    this.body = body;
  }
}

export class PreviewTemplateImportDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_IMPORT_PREVIEW;
  public method = METHOD.POST;
  public body: FormData;
  public readonly responseClass: unknown;
  public query: undefined;

  constructor(file: File) {
    super();
    this.body = new FormData();
    this.body.append('file', file);
  }
}

export class CommitTemplateImportDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.TEMPLATE_IMPORT_COMMIT;
  public method = METHOD.POST;
  public body: FormData;
  public readonly responseClass: unknown;
  public query: undefined;

  constructor(
    file: File,
    expectedHash: string,
    decisions: ITemplateImportDecision[],
  ) {
    super();
    this.body = new FormData();
    this.body.append('file', file);
    this.body.append('expectedHash', expectedHash);
    this.body.append('decisions', JSON.stringify(decisions));
  }
}
